import axios from "axios";
import { Base64 } from "js-base64";

const state = {
  isLogin: sessionStorage.getItem("isAdmin") ? true : false,
  isAdmin: sessionStorage.getItem("isAdmin") || false,
  userId: sessionStorage.getItem("userId") || null
};

const getters = {
  isAdmin(state) {
    if (!state.userId) return false;
    return state.isAdmin;
  },
  user(state) {
    return state.userId;
  }
};

const mutations = {
  loggedIn(state, data) {
    sessionStorage.setItem("accessToken", data.token);
    sessionStorage.setItem("userId", data.user.id);
    sessionStorage.setItem("isAdmin", data.user.is_admin);
    state.isLogin = true;
    state.isAdmin = data.user.is_admin;
    state.userId = data.user.id;
  },
  loggedOut(state) {
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("isAdmin");
    state.isLogin = false;
    state.isAdmin = false;
    state.userId = null;
  }
};

const actions = {
  async register({ commit, state }, { user, successCallback, errorCallback }) {
    // if (!state.isAdmin) return false; todo
    const postUser = Object.assign({}, user);
    postUser.password = Base64.encode(postUser.password.toString());
    return axios
      .post("/api/user/register", { ...postUser })
      .then(response => {
        if (successCallback != null) successCallback(response);
        return true;
      })
      .catch(error => {
        commit("error", error);
        if (errorCallback != null) errorCallback(error);
        return false;
      });
  },
  async login({ commit, state }, { user, successCallback, errorCallback }) {
    // if (state.isLogin) return false;
    const postUser = Object.assign({}, user);
    postUser.password = Base64.encode(postUser.password.toString());
    return axios
      .post("/api/user/login", { ...postUser })
      .then(response => {
        commit("loggedIn", response.data);
        if (successCallback != null) successCallback(response);
        return true;
      })
      .catch(error => {
        commit("error", error);
        if (errorCallback != null) errorCallback(error);
        return false;
      });
  },
  async logout({ commit, state }) {
    if (!state.isLogin) return false;
    return axios
      .get("/api/user/logout")
      .then(() => {
        commit("loggedOut");
        return true;
      })
      .catch(error => {
        commit("error", error);
        return false;
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
